/**
 * @file SafetyCopyRow.tsx
 * @description Галочка страховочной копии (решения 2026-10-12): «Сначала
 * сохранить их дизайном «Черновик 12.10»» в окне создания и «Сначала
 * сохранить вид с сайта как дизайн «…»» в окне обновления. Включена по
 * умолчанию; нет места среди дизайнов — неактивна с объяснением.
 */

import { CheckRow } from "../../site-view/CheckRow";

/** Подпись под неактивной галочкой — одна на оба окна. */
export const SAFETY_COPY_FULL_TEXT = "Нет места для страховочной копии — удалите ненужный дизайн или продолжите без неё";

interface Props {
  checked: boolean;
  onChange: (value: boolean) => void;
  /** Места под копию нет (лимит дизайнов). */
  full: boolean;
  children: string;
}

export function SafetyCopyRow({ checked, onChange, full, children }: Props) {
  return (
    <div className="flex flex-col">
      <CheckRow checked={checked && !full} disabled={full} onChange={onChange}>
        {children}
      </CheckRow>
      {full ? <span className="type-caption pl-8 text-on-surface-variant">{SAFETY_COPY_FULL_TEXT}</span> : null}
    </div>
  );
}

/**
 * Низ окна — липкий до самого края (на телефоне окно во весь экран, на ПК —
 * с прокруткой при длинном списке): у окна поле 24px, а липкая граница
 * считается от внутреннего края, поэтому `-bottom-6` и свои поля.
 */
export const STICKY_FOOTER =
  "sticky -bottom-6 -mx-6 -mb-6 mt-auto bg-surface-lowest px-6 py-3 [box-shadow:0_-1px_0_var(--border)] sm:rounded-b-xl";
